module.exports = "\n.list { margin-top: -3px; }\n\n.list li { padding-bottom: 10px; }\n\n.negative-mt { margin-top: -15px !important }\n\n.list .title { height: 55px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/menu-forum/menu-forum.component.css
// module id = ./src/app/shared/menu-forum/menu-forum.component.css
// module chunks = main